export default [
    {
        path: '/customers',
        name: 'Company / Customers',
        component: () => import('@/views/pages/customers'),
        meta:
        {
            page: 'list',
        },
        children:
        [
            {
                path: 'overview',
                name: 'Company / Customer Overview',
                component: () => import('@/views/pages/customers'),
                meta:
                {
                    page: 'overview',
                    subPage: 'main',
                },
            },
            {
                path: ':code',
                name: 'Company / View Customer',
                component: () => import('@/views/pages/customers'),
                meta:
                {
                    page: 'view',
                },
            },
        ],
    },
];